import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import {
  IUser,
  IUserLoginPayload,
  IUserLoginResponse,
  IUserUpdatePasswordPayload,
  IUserUpdateProfilePayload,
} from "../../../types/api/user";
import { TResponse } from "../../../types/common";
import { AxiosResponse } from "axios";

export async function userUpdatePassword(
  data: IUserUpdatePasswordPayload
): Promise<AxiosResponse<TResponse<IUser>>> {
  return axios.post<TResponse<IUser>>(
    API_ENDPOINTS.ADMIN_UPDATE_PASSWORD,
    data
  );
}
export async function validateToken(): Promise<
  AxiosResponse<TResponse<IUserLoginResponse>>
> {
  return axios.get<TResponse<IUserLoginResponse>>(API_ENDPOINTS.VALIDATE_TOKEN);
}

export async function userUpdatedProfile(
  data: IUserUpdateProfilePayload
): Promise<AxiosResponse<TResponse<IUser>>> {
  return axios.post<TResponse<IUser>>(API_ENDPOINTS.ADMIN_SAVE, data);
}

export async function getUserInfo(): Promise<AxiosResponse<TResponse<IUser>>> {
  return axios.get<TResponse<IUser>>(API_ENDPOINTS.ADMIN_DETAIL);
}

export async function userLogin(
  data: IUserLoginPayload
): Promise<AxiosResponse<TResponse<IUserLoginResponse>>> {
  return axios.post<TResponse<IUserLoginResponse>>(
    API_ENDPOINTS.ADMIN_LOGIN,
    data
  );
}
